import { render } from "./404.vue?vue&type=template&id=55bc830b&scoped=true"
const script = {}

import "./404.vue?vue&type=style&index=0&id=55bc830b&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55bc830b"]])

export default __exports__